<template>
  <div>

    <div class="form_login form-body" :class="{ 'active': login == true }">
      <div class="close_btn">
        <a href="javascript:void(0)" @click="login = false">
          <i class="fa-solid fa-xmark"></i>
        </a>
      </div>

      <div class="header">
        <h1>เข้าสู่ระบบ</h1>
      </div>
      <div style="height: 90% ;overflow: scroll;">
        <div class="phone">
          <label for="">เบอร์โทรศัพท์</label>
          <input type="text" v-model="phoneNumber" name="phone" id="login_phone_mb">
        </div>
        <div class="password">
          <label for="">รหัสผ่าน</label>
          <input type="password" v-model="password" name="" id="login_password_mb">
        </div>

        <div>

          <input v-model="remember" :value="true" type="checkbox" id="f-condition" class="form-check-input"
            style="border-radius: 0;" />
          <label for="f-condition" class="form-check-label mx-2">
            จดจำฉันไว้ในระบบ
          </label>
        </div>


        <div class="btn_from">
          <input type="button" @click="Login()" id="submitlogin" value="เข้าสู่ระบบ">
        </div>
        <div class="register_link">
          <p>ยังไม่ได้สมัครสมาชิกใช่ไหม คลิ๊กที่นี่ เพื่อ <a href="javascript:void(0)"
              @click="register = true; login = false" class="link_reg">สมัครสมาชิก</a></p>
        </div>

      </div>

    </div>

    <div class="form_register form-body" :class="{ 'active': register == true }">
      <div class="close_btn_2">
        <a href="javascript:void(0)" @click="register = false">
          <i class="fa-solid fa-xmark"></i>
        </a>
      </div>
      <div class="header">
        <h1>สมัครสมาชิก</h1>
      </div>

      <div style="height: 90% ;overflow: scroll;">
        <div class="reg-container" v-if="ReqStep == 2">
          <div class="standard-form-container">
            <div class="phone">
              <label for="">เบอร์โทรศัพท์</label>
              <input type="text" id="phone_mb" v-model="PhoneNumber">
            </div>

          </div>

        </div>

        <div class="reg-container" v-if="ReqStep == 2">
          <div class="standard-form-container reg-step-2 ">

            <div class="select_value">
              <select class="form-select form-control form-control-form bg-border-select"
                aria-label="Default select example" v-model="BankCode">
                <option selected="selected" value="-1">
                  --- เลือกธนาคาร ---
                </option>
                <option v-for="(  item, i  ) in   nameBankArrayList  " :key="i" :value="item.id">
                  {{ item.value }}
                </option>
              </select>

            </div>

            <div class="phone">
              <label for="">เลขบัญชี</label>
              <input type="text" v-model="BankNumber" id="phone_true">
            </div>

            <div class="btn_from">
              <input @click="ReqStep = 1" type="button" id="submitregister" value="กลับ">
            </div>
            <div class="btn_from">
              <input @click="Register()" type="button" id="submitregister" value="ถัดไป">
            </div>
          </div>
          

        </div>

        <div class="reg-container" v-if="ReqStep == 1">
          <div class="standard-form-container reg-step-2">

            <div class="phone">
              <label for="">เบอร์โทรศัพท์</label>
              <input type="text" id="phone_mb" v-model="PhoneNumber">
            </div>

            <div class="password">
              <label for="">รหัสผ่าน</label>
              <input type="text" v-model="Password" id="password_mb">
            </div>

            <div class="btn_from">
              <input @click="Register()" type="button" id="submitregister" value="ถัดไป">
            </div>


          </div>

        </div>

        <div class="reg-container" v-if="ReqStep == 3">
          <div class="standard-form-container reg-step-2">

            <div class="phone">
              <label for="">เบอร์โทรศัพท์</label>
              <input type="text" readonly id="phone_mb" v-model="PhoneNumber">
            </div>

            <div class="select_value">
              <select readonly class="form-select form-control form-control-form bg-border-select"
                aria-label="Default select example" v-model="BankCode">
                <option selected="selected" disabled="disabled" value="-1">
                  --- เลือกธนาคาร ---
                </option>
                <option v-for="(  item, i  ) in   nameBankArrayList  " :key="i" :value="item.id">
                  {{ item.value }}
                </option>
              </select>

            </div>

            <div class="phone">
              <label for="">เลขที่บัญชี</label>
              <input type="tel" readonly v-model="BankNumber" id="password_mb">
            </div>


            <div class="phone">
              <label for="">ชื่อ</label>
              <input type="text" :disabled="tokenBank != ''" v-model="FirstName" id="password_mb">
            </div>

            <div class="phone">
              <label for="">นามสกุล</label>
              <input type="text" :disabled="tokenBank != ''" v-model="LastName" id="password_mb">
            </div>

            <div class="phone">
              <label for="">รหัสแนะนำ</label>
              <input type="text" readonly v-model="shareToken" id="password_mb">
            </div>

            <div class="standard-radio-container">

<div class="mb-3" style="padding: 15px;">
  <div class="form-check">
    <input class="form-check-input" type="radio" name="flexRadioDefault" v-model="isBonus" :value="true"
      id="flexRadioDefault1" />
    <label class="form-check-label" for="flexRadioDefault1">
      รับโปรโมชั่น
    </label>


  </div>
  <div class="form-check">
    <input class="form-check-input" type="radio" v-model="isBonus" :value="false" name="flexRadioDefault"
      id="flexRadioDefault2" checked />
    <label class="form-check-label" for="flexRadioDefault2">
      ไม่รับโปรโมชั่น
    </label>


  </div>
</div>
</div>

            <div class="btn_from">
              <input @click="ReqStep = 2" type="button" id="submitregister" value="กลับ">
            </div>
            <div class="btn_from">
              <input @click="Register()" type="button" id="submitregister" value="สมัคร">
            </div>


          </div>

        </div>

        <div class="register_link">
          <p>เป็นสมาชิกแล้วใช่ไหม คลิ๊กที่นี่ เพื่อ <a href="javascript:void(0)" @click="register = false; login = true"
              class="link_log">เข้าสู่ระบบ</a></p>
        </div>
      </div>
    </div>
    <div class="overlay" :class="{ 'active': register == true || login == true }"
      @click="register = false; login = false"></div>
    <nav class="navbar">
      <div class="container">
        <div class="logo">
          <a href="/">
            <img src="/static/img/logo/logo.png" alt="" style="max-height: 80px; max-width: 80px;">
          </a>
        </div>

        <div class="row_btn">
          <div class="login_btn">
            <a href="javascript:void(0)" @click="register = false; login = true">เข้าสู่ระบบ</a>
          </div>

          <div class="register">
            <a href="javascript:void(0)" @click="register = true; login = false">สมัครสมาชิก</a>
          </div>
        </div>
      </div>
    </nav>
    <div class="menu_mobile">
      <div class="container_menu">
        <div class="menu_item">
          <a href="/">
            <img src="/static/img/icon/1055814.png" alt="">
            <p>หน้าแรก</p>
          </a>
        </div>
        <div class="menu_item">
          <a href="javascript:void(0)" @click="register = true; login = false" id="register_mobile">
            <img src="/static/img/icon/9068899.png" alt="">
            <p>สมัคร</p>
          </a>
        </div>
        <div class="menu_item">
          <a href="javascript:void(0)" @click="register = false; login = true" id="login_mobile">
            <img src="/static/img/icon/7847423.png" alt="">
            <p>เข้าสู่ระบบ</p>
          </a>
        </div>
        <div class="menu_item">
          <a href="/">
            <img src="/static/img/icon/5002461.png" alt="">
            <p>โปรโมชั่น</p>
          </a>
        </div>
        <div class="menu_item">
          <a v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank">
            <img src="/static/img/icon/4103011.png" alt="">
            <p>ติดต่อ</p>
          </a>
        </div>
      </div>
    </div>

    <router-view />


  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { BankMixins } from "@/mixins/BankService.js";
import api from "@/services/index.js";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { nameBankArray } from "@/services/modules/Bank.services.js";
import { nameBankArrayList } from "@/config/Bank.js";
import { checkPhoneNumber, checkBankNumber } from "@/services/modules/user.js";

export default {
  name: "App",
  data() {
    return {
      Prefix: [],
      register: false,
      login: false,
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,

      // register

      PhoneNumber: "",
      Password: "",
      ConfirmPassword: "",
      BankCode: "-1",
      BankNumber: "",
      FirstName: "",
      LastName: "",
      SignupToken: "",
      tokenBank: "",
      shareToken: this.$route.params.shareToken,
      isBonus: false,
      nameBankArrayList: nameBankArrayList,
      ReqStep: 1,

    };
  },
  components: { Header, Footer },
  computed: {
    ...mapGetters(["getAppId", "getError", "getLoading", "getLineId"]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError", "userSignUp"]),
    ...mapMutations([
      "setAlertMessage",
      "setAlertImage",
      "setLogoUrl",
      "setAppId",
      "setLineId",
      "setPhotoCashback",
      "setPhotoAffiliate",
    ]),
    async Register() {
      this.setError(null);
      if (this.ReqStep == 1) {
        return this.Step1checkPhoneNumber();
      } else if (this.ReqStep == 2) {
        return this.Step2checkBankNumber();
      } else {
        let registerDATA = {
          phoneNumber: this.PhoneNumber,
          Password: this.Password,
          Confirm_Password: this.Password,
          BankAccount: this.BankNumber,
          BankCode: this.BankCode,
          firstName: this.FirstName,
          lastName: this.LastName,
          tokenBank: this.tokenBank,
          affiliateKey: this.shareToken,
          isBonus: this.isBonus,
        };
        await this.userSignUp(registerDATA);
        if (this.getError) {
          return this.$swal.fire(this.getError, "", "error");
        } else {
          return this.$swal.fire("ลงทะเบียนเรียบร้อยแล้ว", "", "success");
        }
      }
    },

    async Step1checkPhoneNumber() {
      if (this.PhoneNumber.length != 10)
        return this.$swal.fire(
          "หมายเลขโทรศัพท์ ไม่ถูกต้อง กรุณากรอกใหม่",
          "",
          "error"
        );
      if (this.PhoneNumber == "" || this.PhoneNumber.length != 10) {
        return this.$swal.fire(
          "หมายเลขโทรศัพท์ ไม่ถูกต้อง กรุณากรอกใหม่",
          "",
          "error"
        );
      }
      await checkPhoneNumber(this.PhoneNumber, (res) => {
        if (res.status) {
          this.ReqStep = 2;
          this.setError(null);
        } else {
          return this.$swal.fire(res.message, "", "error");
        }
      });
    },
    async Step2checkBankNumber() {
      if (
        this.BankCode == "-1" ||
        (this.BankNumber.length != 10 && this.BankNumber.length != 12)
      ) {
        // return this.setError('กรุณากรอกข้อมูลก่อนยืนยัน')
        return this.$swal.fire("กรุณากรอกข้อมูลก่อนยืนยัน", "", "error");
      }

      await checkBankNumber(this.BankNumber, this.BankCode, (res) => {
        if (res.status) {
          if (res.data) {
            if (res.data.firstName != undefined) {
              this.FirstName = res.data.firstName;
            }
            if (res.data.lastName != undefined) {
              this.LastName = res.data.lastName;
            }
            if (res.data.token != undefined) {
              this.tokenBank = res.data.token;
            }
          }
          this.ReqStep = 3;
          this.setError(null);
        } else {
          return this.$swal.fire(res.message, "", "error");
        }
      });
    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    async changeCat(cate) {
      await this.$router.push('/').catch(() => { });
      this.cate = cate
    },
    gotoRoute(route) {
      this.$router.push(route).catch(() => { });
    },
    async setFavicons(favImg) {
      let headTitle = document.querySelector("head");
      let setFavicon = document.createElement("link");
      setFavicon.setAttribute("rel", "shortcut icon");
      setFavicon.setAttribute("href", favImg);
      headTitle.appendChild(setFavicon);
    },
    async InitConfig() {
      this.setAppId(this.Prefix.appId);
      this.setPhotoCashback(this.Prefix.cashBack.Image || null);
      this.setPhotoAffiliate(this.Prefix.Affiliate.Image || null);
      this.setAppId(this.Prefix.appId);
      this.setLineId(this.Prefix.LineId);
      this.setLogoUrl(this.Prefix.logoUrl);
      this.setFavicons(this.Prefix.logoUrl);
      this.setAlertImage(this.Prefix.alertyImage);
      this.setAlertMessage(this.Prefix.alertyMessage);
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`);
      document
        .querySelector('meta[name="og:title"]')
        .setAttribute("content", `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`);
      document
        .querySelector('meta[name="og:description"]')
        .setAttribute("content", `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`);
      document
        .querySelector('meta[name="og:image"]')
        .setAttribute("content", this.Prefix.logoUrl);
      document.documentElement.setAttribute(
        "class",
        `${this.Prefix.theme}-theme`
      );
      document.documentElement.setAttribute("lang", `th`);
      document.title = `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`;
    },
  },
  async beforeCreate() {
    await api.get("/v2/prefix").then((v) => {
      if (v.success == true) {
        this.Prefix = v.data;
        this.InitConfig();
      } else {
      }
    });
  },

  async mounted() {
    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/index/App.vue